/**
 * Format a phone number for display in the Action Center banners.
 * Falls back to the raw input when it is not a recognizable US number.
 */
export const formatPhoneForDisplay = (phone: string): string => {
  if (!phone) {
    return '';
  }

  const digits = phone.replace(/\D/g, '');
  const national = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;

  if (national.length === 10) {
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`;
  }

  return phone;
};

/**
 * Phone to restore after GET-by-id. Matched/multiple views keep using the
 * contact's stored number so refresh behavior stays unchanged. A NONE lookup
 * has no matches, so the searched number must come from the lookup row.
 */
export const phoneForRestoredLookup = (
  matches: IActionCenterLookupMatch[],
  phoneNormalized?: string | null
): string => {
  if (matches.length) {
    return matches[0].cellPhone || matches[0].workPhone || '';
  }

  return phoneNormalized || '';
};

export const contactTypeLabel = (contactType: ContactType | null): string => {
  if (contactType === ContactType.LEGAL_ENTITY) {
    return 'Legal Entity';
  }

  return 'Individual';
};
